import React, { useRef } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import Spinner from "./Spinner";

function Datepicker({
  selectedDate,
  onChange,
  onFocus,
  className,
  allowedDates,
}) {
  const datePickerRef = useRef(null); // Ref for the datepicker
  const { loading, error } = useSelector((state) => state.toursAvailableDates);

  // Check if a date is allowed
  const isAllowedDate = (date) =>
    allowedDates?.some(
      (allowedDate) => allowedDate.toDateString() === date.toDateString()
    );

  return (
    <div className={`leap-relative ${className}`}>
      <div className="leap-relative leap-w-full leap-h-[56px]">
        {/* Spinner overlay */}
        {loading && (
          <div className="leap-absolute leap-inset-0 leap-bg-black/50 leap-flex leap-items-center leap-justify-center leap-rounded-[16px] leap-z-10">
            <div className="leap-scale-50">
              <Spinner />
            </div>
          </div>
        )}

        {/* Datepicker */}
        <ReactDatePicker
          ref={datePickerRef} // Attach the ref
          selected={selectedDate}
          onChange={onChange}
          onClick={() => datePickerRef.current?.setFocus()} // Focus the datepicker on icon click
          onFocus={onFocus}
          dateFormat="MM/dd/yyyy"
          includeDates={allowedDates}
          className={`leap-w-full leap-min-h-[56px] leap-bg-[#2e3351] !leap-rounded-[16px] leap-px-4 leap-text-lg leap-text-white focus:leap-outline-none focus:leap-ring-2 focus:leap-ring-[#73FAFD] ${
            loading ? "leap-pointer-events-none" : ""
          }`}
          calendarClassName="leap-bg-[#191733] leap-text-white leap-rounded-lg leap-shadow-lg leap-border leap-border-[#73FAFD] leap-p-4"
          dayClassName={(date) => {
            if (isAllowedDate(date)) {
              return "leap-text-white leap-rounded-md hover:leap-bg-[#73FAFD] hover:leap-text-black";
            } else {
              return "leap-text-gray-500 leap-opacity-50 leap-pointer-events-none";
            }
          }}
          weekDayClassName={() => "leap-text-[#73FAFD]"}
          todayButtonClassName="leap-bg-[#73FAFD] leap-text-black leap-py-2 leap-px-4 leap-rounded-lg leap-mt-2"
          placeholderText="SELECT DATE"
          disabled={loading}
        />
      </div>
      {/* Calendar icon */}
      <FaCalendarAlt
        onClick={() => datePickerRef.current?.setFocus()} // Focus the datepicker on icon click
        className={`leap-absolute leap-top-1/2 leap-right-4 leap-transform leap--translate-y-1/2 leap-text-[#73FAFD] leap-text-xl pointer-events-auto ${
          loading ? "leap-opacity-50" : ""
        }`}
      />
    </div>
  );
}

export default Datepicker;
